import './MessageBox.css';
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class MessageBoxForInvalidPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: 'You are not allowed to access this page.',
      notAllowed: false,
    };
  }
  handleInvalidPage = () => {
    this.setState({
      notAllowed: true,
    });
  };
  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'js/modal.js';
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    if (this.state.notAllowed) {
      console.log('Redirection is done for not allowed page');
      return <Navigate to={'/pageNotAllowed'} />;
    }
    return (
      <>
        <div className='content-wrapper1'>
          <div className='row'></div>
          <div className='modal fade' id='modal-default'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div
                  className='modal-header'
                  style={{
                    background: 'rgb(60, 141, 188)',
                    color: '#fff',
                  }}
                >
                  <button
                    type='button'
                    className='close'
                    data-dismiss='modal'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>×</span>
                  </button>
                  <h4 className='modal-title'>Notifications</h4>
                </div>
                <div className='modal-body'>
                  <p>{this.state.message}</p>
                </div>
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary deca-btn-orange'
                    onClick={this.handleInvalidPage}
                    data-dismiss='modal'
                  >
                    Ok
                  </button>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </div>
      </>
    );
  }
}

export default MessageBoxForInvalidPage;
